
import * as antlr from "antlr4ng";
import { Token } from "antlr4ng";

import { FrendsExpressionParserListener } from "./FrendsExpressionParserListener.js";
// for running tests with parameters, TODO: discuss strategy for typed parameters in CI
// eslint-disable-next-line no-unused-vars
type int = number;


export class FrendsExpressionParser extends antlr.Parser {
    public static readonly EACH_OPEN = 1;
    public static readonly END_EACH_TAG = 2;
    public static readonly IF_OPEN = 3;
    public static readonly ELSE_IF_OPEN = 4;
    public static readonly ELSE_TAG = 5;
    public static readonly END_IF_TAG = 6;
    public static readonly OPEN_BRACES = 7;
    public static readonly STRING = 8;
    public static readonly CLOSE_BRACES = 9;
    public static readonly VAR_REF = 10;
    public static readonly TRIGGER_REF = 11;
    public static readonly PROCESS_REF = 12;
    public static readonly ENV_REF_START = 13;
    public static readonly RESULT_NODE_REF = 14;
    public static readonly RESULT_REF = 15;
    public static readonly THIS_REF = 16;
    public static readonly INDEX_REF = 17;
    public static readonly SOURCE_REF = 18;
    public static readonly CS_TEXT = 19;
    public static readonly ENV_VAR_VALUE = 20;
    public static readonly RULE_textExpressionRoot = 0;
    public static readonly RULE_csExpressionRoot = 1;
    public static readonly RULE_textExpression = 2;
    public static readonly RULE_interpolatedExpression = 3;
    public static readonly RULE_eachStatement = 4;
    public static readonly RULE_ifStatement = 5;
    public static readonly RULE_ifBranch = 6;
    public static readonly RULE_elseIfBranch = 7;
    public static readonly RULE_elseBranch = 8;
    public static readonly RULE_csExpression = 9;
    public static readonly RULE_nonEmptyCsExpression = 10;
    public static readonly RULE_reference = 11;
    public static readonly RULE_varRef = 12;
    public static readonly RULE_triggerRef = 13;
    public static readonly RULE_processRef = 14;
    public static readonly RULE_envRef = 15;
    public static readonly RULE_resultNodeRef = 16;
    public static readonly RULE_resultRef = 17;
    public static readonly RULE_thisRef = 18;
    public static readonly RULE_indexRef = 19;
    public static readonly RULE_sourceRef = 20;
    public static readonly RULE_csText = 21;
    public static readonly RULE_string = 22;

    public static readonly literalNames = [
        null, null, null, null, null, null, null, "'{{'", null, "'}}'"
    ];

    public static readonly symbolicNames = [
        null, "EACH_OPEN", "END_EACH_TAG", "IF_OPEN", "ELSE_IF_OPEN", "ELSE_TAG", 
        "END_IF_TAG", "OPEN_BRACES", "STRING", "CLOSE_BRACES", "VAR_REF", 
        "TRIGGER_REF", "PROCESS_REF", "ENV_REF_START", "RESULT_NODE_REF", 
        "RESULT_REF", "THIS_REF", "INDEX_REF", "SOURCE_REF", "CS_TEXT", 
        "ENV_VAR_VALUE"
    ];
    public static readonly ruleNames = [
        "textExpressionRoot", "csExpressionRoot", "textExpression", "interpolatedExpression", 
        "eachStatement", "ifStatement", "ifBranch", "elseIfBranch", "elseBranch", 
        "csExpression", "nonEmptyCsExpression", "reference", "varRef", "triggerRef", 
        "processRef", "envRef", "resultNodeRef", "resultRef", "thisRef", 
        "indexRef", "sourceRef", "csText", "string",
    ];

    public get grammarFileName(): string { return "FrendsExpressionParser.g4"; }
    public get literalNames(): (string | null)[] { return FrendsExpressionParser.literalNames; }
    public get symbolicNames(): (string | null)[] { return FrendsExpressionParser.symbolicNames; }
    public get ruleNames(): string[] { return FrendsExpressionParser.ruleNames; }
    public get serializedATN(): number[] { return FrendsExpressionParser._serializedATN; }

    protected createFailedPredicateException(predicate?: string, message?: string): antlr.FailedPredicateException {
        return new antlr.FailedPredicateException(this, predicate, message);
    }

    public constructor(input: antlr.TokenStream) {
        super(input);
        this.interpreter = new antlr.ParserATNSimulator(this, FrendsExpressionParser._ATN, FrendsExpressionParser.decisionsToDFA, new antlr.PredictionContextCache());
    }
    public textExpressionRoot(): TextExpressionRootContext {
        let localContext = new TextExpressionRootContext(this.context, this.state);
        this.enterRule(localContext, 0, FrendsExpressionParser.RULE_textExpressionRoot);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 46;
            this.textExpression();
            this.state = 47;
            this.match(FrendsExpressionParser.EOF);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public csExpressionRoot(): CsExpressionRootContext {
        let localContext = new CsExpressionRootContext(this.context, this.state);
        this.enterRule(localContext, 2, FrendsExpressionParser.RULE_csExpressionRoot);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 49;
            this.csExpression();
            this.state = 50;
            this.match(FrendsExpressionParser.EOF);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public textExpression(): TextExpressionContext {
        let localContext = new TextExpressionContext(this.context, this.state);
        this.enterRule(localContext, 4, FrendsExpressionParser.RULE_textExpression);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 58;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            while ((((_la) & ~0x1F) === 0 && ((1 << _la) & 394) !== 0)) {
                {
                this.state = 56;
                this.errorHandler.sync(this);
                switch (this.tokenStream.LA(1)) {
                case FrendsExpressionParser.EACH_OPEN:
                    {
                    this.state = 52;
                    this.eachStatement();
                    }
                    break;
                case FrendsExpressionParser.IF_OPEN:
                    {
                    this.state = 53;
                    this.ifStatement();
                    }
                    break;
                case FrendsExpressionParser.OPEN_BRACES:
                    {
                    this.state = 54;
                    this.interpolatedExpression();
                    }
                    break;
                case FrendsExpressionParser.STRING:
                    {
                    this.state = 55;
                    this.string_();
                    }
                    break;
                default:
                    throw new antlr.NoViableAltException(this);
                }
                }
                this.state = 60;
                this.errorHandler.sync(this);
                _la = this.tokenStream.LA(1);
            }
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public interpolatedExpression(): InterpolatedExpressionContext {
        let localContext = new InterpolatedExpressionContext(this.context, this.state);
        this.enterRule(localContext, 6, FrendsExpressionParser.RULE_interpolatedExpression);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 61;
            this.match(FrendsExpressionParser.OPEN_BRACES);
            this.state = 62;
            this.csExpression();
            this.state = 63;
            this.match(FrendsExpressionParser.CLOSE_BRACES);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public eachStatement(): EachStatementContext {
        let localContext = new EachStatementContext(this.context, this.state);
        this.enterRule(localContext, 8, FrendsExpressionParser.RULE_eachStatement);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 65;
            this.match(FrendsExpressionParser.EACH_OPEN);
            this.state = 66;
            this.nonEmptyCsExpression();
            this.state = 67;
            this.match(FrendsExpressionParser.CLOSE_BRACES);
            this.state = 68;
            this.textExpression();
            this.state = 69;
            this.match(FrendsExpressionParser.END_EACH_TAG);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public ifStatement(): IfStatementContext {
        let localContext = new IfStatementContext(this.context, this.state);
        this.enterRule(localContext, 10, FrendsExpressionParser.RULE_ifStatement);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 71;
            this.ifBranch();
            this.state = 75;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            while (_la === 4) {
                {
                {
                this.state = 72;
                this.elseIfBranch();
                }
                }
                this.state = 77;
                this.errorHandler.sync(this);
                _la = this.tokenStream.LA(1);
            }
            this.state = 79;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            if (_la === 5) {
                {
                this.state = 78;
                this.elseBranch();
                }
            }

            this.state = 81;
            this.match(FrendsExpressionParser.END_IF_TAG);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public ifBranch(): IfBranchContext {
        let localContext = new IfBranchContext(this.context, this.state);
        this.enterRule(localContext, 12, FrendsExpressionParser.RULE_ifBranch);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 83;
            this.match(FrendsExpressionParser.IF_OPEN);
            this.state = 84;
            this.nonEmptyCsExpression();
            this.state = 85;
            this.match(FrendsExpressionParser.CLOSE_BRACES);
            this.state = 86;
            this.textExpression();
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public elseIfBranch(): ElseIfBranchContext {
        let localContext = new ElseIfBranchContext(this.context, this.state);
        this.enterRule(localContext, 14, FrendsExpressionParser.RULE_elseIfBranch);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 88;
            this.match(FrendsExpressionParser.ELSE_IF_OPEN);
            this.state = 89;
            this.nonEmptyCsExpression();
            this.state = 90;
            this.match(FrendsExpressionParser.CLOSE_BRACES);
            this.state = 91;
            this.textExpression();
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public elseBranch(): ElseBranchContext {
        let localContext = new ElseBranchContext(this.context, this.state);
        this.enterRule(localContext, 16, FrendsExpressionParser.RULE_elseBranch);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 93;
            this.match(FrendsExpressionParser.ELSE_TAG);
            this.state = 94;
            this.textExpression();
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public csExpression(): CsExpressionContext {
        let localContext = new CsExpressionContext(this.context, this.state);
        this.enterRule(localContext, 18, FrendsExpressionParser.RULE_csExpression);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 100;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            while ((((_la) & ~0x1F) === 0 && ((1 << _la) & 1047552) !== 0)) {
                {
                this.state = 98;
                this.errorHandler.sync(this);
                switch (this.tokenStream.LA(1)) {
                case FrendsExpressionParser.VAR_REF:
                case FrendsExpressionParser.TRIGGER_REF:
                case FrendsExpressionParser.PROCESS_REF:
                case FrendsExpressionParser.ENV_REF_START:
                case FrendsExpressionParser.RESULT_NODE_REF:
                case FrendsExpressionParser.RESULT_REF:
                case FrendsExpressionParser.THIS_REF:
                case FrendsExpressionParser.INDEX_REF:
                case FrendsExpressionParser.SOURCE_REF:
                    {
                    this.state = 96;
                    this.reference();
                    }
                    break;
                case FrendsExpressionParser.CS_TEXT:
                    {
                    this.state = 97;
                    this.csText();
                    }
                    break;
                default:
                    throw new antlr.NoViableAltException(this);
                }
                }
                this.state = 102;
                this.errorHandler.sync(this);
                _la = this.tokenStream.LA(1);
            }
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public nonEmptyCsExpression(): NonEmptyCsExpressionContext {
        let localContext = new NonEmptyCsExpressionContext(this.context, this.state);
        this.enterRule(localContext, 20, FrendsExpressionParser.RULE_nonEmptyCsExpression);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 105;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            do {
                {
                this.state = 105;
                this.errorHandler.sync(this);
                switch (this.tokenStream.LA(1)) {
                case FrendsExpressionParser.VAR_REF:
                case FrendsExpressionParser.TRIGGER_REF:
                case FrendsExpressionParser.PROCESS_REF:
                case FrendsExpressionParser.ENV_REF_START:
                case FrendsExpressionParser.RESULT_NODE_REF:
                case FrendsExpressionParser.RESULT_REF:
                case FrendsExpressionParser.THIS_REF:
                case FrendsExpressionParser.INDEX_REF:
                case FrendsExpressionParser.SOURCE_REF:
                    {
                    this.state = 103;
                    this.reference();
                    }
                    break;
                case FrendsExpressionParser.CS_TEXT:
                    {
                    this.state = 104;
                    this.csText();
                    }
                    break;
                default:
                    throw new antlr.NoViableAltException(this);
                }
                }
                this.state = 107;
                this.errorHandler.sync(this);
                _la = this.tokenStream.LA(1);
            } while ((((_la) & ~0x1F) === 0 && ((1 << _la) & 1047552) !== 0));
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public reference(): ReferenceContext {
        let localContext = new ReferenceContext(this.context, this.state);
        this.enterRule(localContext, 22, FrendsExpressionParser.RULE_reference);
        try {
            this.state = 118;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case FrendsExpressionParser.VAR_REF:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 109;
                this.varRef();
                }
                break;
            case FrendsExpressionParser.TRIGGER_REF:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 110;
                this.triggerRef();
                }
                break;
            case FrendsExpressionParser.PROCESS_REF:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 111;
                this.processRef();
                }
                break;
            case FrendsExpressionParser.ENV_REF_START:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 112;
                this.envRef();
                }
                break;
            case FrendsExpressionParser.RESULT_NODE_REF:
                this.enterOuterAlt(localContext, 5);
                {
                this.state = 113;
                this.resultNodeRef();
                }
                break;
            case FrendsExpressionParser.RESULT_REF:
                this.enterOuterAlt(localContext, 6);
                {
                this.state = 114;
                this.resultRef();
                }
                break;
            case FrendsExpressionParser.THIS_REF:
                this.enterOuterAlt(localContext, 7);
                {
                this.state = 115;
                this.thisRef();
                }
                break;
            case FrendsExpressionParser.INDEX_REF:
                this.enterOuterAlt(localContext, 8);
                {
                this.state = 116;
                this.indexRef();
                }
                break;
            case FrendsExpressionParser.SOURCE_REF:
                this.enterOuterAlt(localContext, 9);
                {
                this.state = 117;
                this.sourceRef();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public varRef(): VarRefContext {
        let localContext = new VarRefContext(this.context, this.state);
        this.enterRule(localContext, 24, FrendsExpressionParser.RULE_varRef);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 120;
            this.match(FrendsExpressionParser.VAR_REF);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public triggerRef(): TriggerRefContext {
        let localContext = new TriggerRefContext(this.context, this.state);
        this.enterRule(localContext, 26, FrendsExpressionParser.RULE_triggerRef);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 122;
            this.match(FrendsExpressionParser.TRIGGER_REF);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public processRef(): ProcessRefContext {
        let localContext = new ProcessRefContext(this.context, this.state);
        this.enterRule(localContext, 28, FrendsExpressionParser.RULE_processRef);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 124;
            this.match(FrendsExpressionParser.PROCESS_REF);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public envRef(): EnvRefContext {
        let localContext = new EnvRefContext(this.context, this.state);
        this.enterRule(localContext, 30, FrendsExpressionParser.RULE_envRef);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 126;
            this.match(FrendsExpressionParser.ENV_REF_START);
            this.state = 128;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            if (_la === 20) {
                {
                this.state = 127;
                this.match(FrendsExpressionParser.ENV_VAR_VALUE);
                }
            }

            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public resultNodeRef(): ResultNodeRefContext {
        let localContext = new ResultNodeRefContext(this.context, this.state);
        this.enterRule(localContext, 32, FrendsExpressionParser.RULE_resultNodeRef);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 130;
            this.match(FrendsExpressionParser.RESULT_NODE_REF);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public resultRef(): ResultRefContext {
        let localContext = new ResultRefContext(this.context, this.state);
        this.enterRule(localContext, 34, FrendsExpressionParser.RULE_resultRef);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 132;
            this.match(FrendsExpressionParser.RESULT_REF);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public thisRef(): ThisRefContext {
        let localContext = new ThisRefContext(this.context, this.state);
        this.enterRule(localContext, 36, FrendsExpressionParser.RULE_thisRef);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 134;
            this.match(FrendsExpressionParser.THIS_REF);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public indexRef(): IndexRefContext {
        let localContext = new IndexRefContext(this.context, this.state);
        this.enterRule(localContext, 38, FrendsExpressionParser.RULE_indexRef);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 136;
            this.match(FrendsExpressionParser.INDEX_REF);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public sourceRef(): SourceRefContext {
        let localContext = new SourceRefContext(this.context, this.state);
        this.enterRule(localContext, 40, FrendsExpressionParser.RULE_sourceRef);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 138;
            this.match(FrendsExpressionParser.SOURCE_REF);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public csText(): CsTextContext {
        let localContext = new CsTextContext(this.context, this.state);
        this.enterRule(localContext, 42, FrendsExpressionParser.RULE_csText);
        try {
            let alternative: number;
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 141;
            this.errorHandler.sync(this);
            alternative = 1;
            do {
                switch (alternative) {
                case 1:
                    {
                    {
                    this.state = 140;
                    this.match(FrendsExpressionParser.CS_TEXT);
                    }
                    }
                    break;
                default:
                    throw new antlr.NoViableAltException(this);
                }
                this.state = 143;
                this.errorHandler.sync(this);
                alternative = this.interpreter.adaptivePredict(this.tokenStream, 10, this.context);
            } while (alternative !== 2 && alternative !== antlr.ATN.INVALID_ALT_NUMBER);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public string_(): StringContext {
        let localContext = new StringContext(this.context, this.state);
        this.enterRule(localContext, 44, FrendsExpressionParser.RULE_string);
        try {
            let alternative: number;
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 146;
            this.errorHandler.sync(this);
            alternative = 1;
            do {
                switch (alternative) {
                case 1:
                    {
                    {
                    this.state = 145;
                    this.match(FrendsExpressionParser.STRING);
                    }
                    }
                    break;
                default:
                    throw new antlr.NoViableAltException(this);
                }
                this.state = 148;
                this.errorHandler.sync(this);
                alternative = this.interpreter.adaptivePredict(this.tokenStream, 11, this.context);
            } while (alternative !== 2 && alternative !== antlr.ATN.INVALID_ALT_NUMBER);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }

    public static readonly _serializedATN: number[] = [
        4,1,20,151,2,0,7,0,2,1,7,1,2,2,7,2,2,3,7,3,2,4,7,4,2,5,7,5,2,6,7,
        6,2,7,7,7,2,8,7,8,2,9,7,9,2,10,7,10,2,11,7,11,2,12,7,12,2,13,7,13,
        2,14,7,14,2,15,7,15,2,16,7,16,2,17,7,17,2,18,7,18,2,19,7,19,2,20,
        7,20,2,21,7,21,2,22,7,22,1,0,1,0,1,0,1,1,1,1,1,1,1,2,1,2,1,2,1,2,
        5,2,57,8,2,10,2,12,2,60,9,2,1,3,1,3,1,3,1,3,1,4,1,4,1,4,1,4,1,4,
        1,4,1,5,1,5,5,5,74,8,5,10,5,12,5,77,9,5,1,5,3,5,80,8,5,1,5,1,5,1,
        6,1,6,1,6,1,6,1,6,1,7,1,7,1,7,1,7,1,7,1,8,1,8,1,8,1,9,1,9,5,9,99,
        8,9,10,9,12,9,102,9,9,1,10,1,10,4,10,106,8,10,11,10,12,10,107,1,
        11,1,11,1,11,1,11,1,11,1,11,1,11,1,11,1,11,3,11,119,8,11,1,12,1,
        12,1,13,1,13,1,14,1,14,1,15,1,15,3,15,129,8,15,1,16,1,16,1,17,1,
        17,1,18,1,18,1,19,1,19,1,20,1,20,1,21,4,21,142,8,21,11,21,12,21,
        143,1,22,4,22,147,8,22,11,22,12,22,148,1,22,0,0,23,0,2,4,6,8,10,
        12,14,16,18,20,22,24,26,28,30,32,34,36,38,40,42,44,0,0,148,0,46,
        1,0,0,0,2,49,1,0,0,0,4,58,1,0,0,0,6,61,1,0,0,0,8,65,1,0,0,0,10,71,
        1,0,0,0,12,83,1,0,0,0,14,88,1,0,0,0,16,93,1,0,0,0,18,100,1,0,0,0,
        20,105,1,0,0,0,22,118,1,0,0,0,24,120,1,0,0,0,26,122,1,0,0,0,28,124,
        1,0,0,0,30,126,1,0,0,0,32,130,1,0,0,0,34,132,1,0,0,0,36,134,1,0,
        0,0,38,136,1,0,0,0,40,138,1,0,0,0,42,141,1,0,0,0,44,146,1,0,0,0,
        46,47,3,4,2,0,47,48,5,0,0,1,48,1,1,0,0,0,49,50,3,18,9,0,50,51,5,
        0,0,1,51,3,1,0,0,0,52,57,3,8,4,0,53,57,3,10,5,0,54,57,3,6,3,0,55,
        57,3,44,22,0,56,52,1,0,0,0,56,53,1,0,0,0,56,54,1,0,0,0,56,55,1,0,
        0,0,57,60,1,0,0,0,58,56,1,0,0,0,58,59,1,0,0,0,59,5,1,0,0,0,60,58,
        1,0,0,0,61,62,5,7,0,0,62,63,3,18,9,0,63,64,5,9,0,0,64,7,1,0,0,0,
        65,66,5,1,0,0,66,67,3,20,10,0,67,68,5,9,0,0,68,69,3,4,2,0,69,70,
        5,2,0,0,70,9,1,0,0,0,71,75,3,12,6,0,72,74,3,14,7,0,73,72,1,0,0,0,
        74,77,1,0,0,0,75,73,1,0,0,0,75,76,1,0,0,0,76,79,1,0,0,0,77,75,1,
        0,0,0,78,80,3,16,8,0,79,78,1,0,0,0,79,80,1,0,0,0,80,81,1,0,0,0,81,
        82,5,6,0,0,82,11,1,0,0,0,83,84,5,3,0,0,84,85,3,20,10,0,85,86,5,9,
        0,0,86,87,3,4,2,0,87,13,1,0,0,0,88,89,5,4,0,0,89,90,3,20,10,0,90,
        91,5,9,0,0,91,92,3,4,2,0,92,15,1,0,0,0,93,94,5,5,0,0,94,95,3,4,2,
        0,95,17,1,0,0,0,96,99,3,22,11,0,97,99,3,42,21,0,98,96,1,0,0,0,98,
        97,1,0,0,0,99,102,1,0,0,0,100,98,1,0,0,0,100,101,1,0,0,0,101,19,
        1,0,0,0,102,100,1,0,0,0,103,106,3,22,11,0,104,106,3,42,21,0,105,
        103,1,0,0,0,105,104,1,0,0,0,106,107,1,0,0,0,107,105,1,0,0,0,107,
        108,1,0,0,0,108,21,1,0,0,0,109,119,3,24,12,0,110,119,3,26,13,0,111,
        119,3,28,14,0,112,119,3,30,15,0,113,119,3,32,16,0,114,119,3,34,17,
        0,115,119,3,36,18,0,116,119,3,38,19,0,117,119,3,40,20,0,118,109,
        1,0,0,0,118,110,1,0,0,0,118,111,1,0,0,0,118,112,1,0,0,0,118,113,
        1,0,0,0,118,114,1,0,0,0,118,115,1,0,0,0,118,116,1,0,0,0,118,117,
        1,0,0,0,119,23,1,0,0,0,120,121,5,10,0,0,121,25,1,0,0,0,122,123,5,
        11,0,0,123,27,1,0,0,0,124,125,5,12,0,0,125,29,1,0,0,0,126,128,5,
        13,0,0,127,129,5,20,0,0,128,127,1,0,0,0,128,129,1,0,0,0,129,31,1,
        0,0,0,130,131,5,14,0,0,131,33,1,0,0,0,132,133,5,15,0,0,133,35,1,
        0,0,0,134,135,5,16,0,0,135,37,1,0,0,0,136,137,5,17,0,0,137,39,1,
        0,0,0,138,139,5,18,0,0,139,41,1,0,0,0,140,142,5,19,0,0,141,140,1,
        0,0,0,142,143,1,0,0,0,143,141,1,0,0,0,143,144,1,0,0,0,144,43,1,0,
        0,0,145,147,5,8,0,0,146,145,1,0,0,0,147,148,1,0,0,0,148,146,1,0,
        0,0,148,149,1,0,0,0,149,45,1,0,0,0,12,56,58,75,79,98,100,105,107,
        118,128,143,148
    ];

    private static __ATN: antlr.ATN;
    public static get _ATN(): antlr.ATN {
        if (!FrendsExpressionParser.__ATN) {
            FrendsExpressionParser.__ATN = new antlr.ATNDeserializer().deserialize(FrendsExpressionParser._serializedATN);
        }

        return FrendsExpressionParser.__ATN;
    }


    private static readonly vocabulary = new antlr.Vocabulary(FrendsExpressionParser.literalNames, FrendsExpressionParser.symbolicNames, []);

    public override get vocabulary(): antlr.Vocabulary {
        return FrendsExpressionParser.vocabulary;
    }

    private static readonly decisionsToDFA = FrendsExpressionParser._ATN.decisionToState.map( (ds: antlr.DecisionState, index: number) => new antlr.DFA(ds, index) );
}

export class TextExpressionRootContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public textExpression(): TextExpressionContext {
        return this.getRuleContext(0, TextExpressionContext)!;
    }
    public EOF(): antlr.TerminalNode {
        return this.getToken(FrendsExpressionParser.EOF, 0)!;
    }
    public override get ruleIndex(): number {
        return FrendsExpressionParser.RULE_textExpressionRoot;
    }
    public override enterRule(listener: FrendsExpressionParserListener): void {
        if(listener.enterTextExpressionRoot) {
             listener.enterTextExpressionRoot(this);
        }
    }
    public override exitRule(listener: FrendsExpressionParserListener): void {
        if(listener.exitTextExpressionRoot) {
             listener.exitTextExpressionRoot(this);
        }
    }
}


export class CsExpressionRootContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public csExpression(): CsExpressionContext {
        return this.getRuleContext(0, CsExpressionContext)!;
    }
    public EOF(): antlr.TerminalNode {
        return this.getToken(FrendsExpressionParser.EOF, 0)!;
    }
    public override get ruleIndex(): number {
        return FrendsExpressionParser.RULE_csExpressionRoot;
    }
    public override enterRule(listener: FrendsExpressionParserListener): void {
        if(listener.enterCsExpressionRoot) {
             listener.enterCsExpressionRoot(this);
        }
    }
    public override exitRule(listener: FrendsExpressionParserListener): void {
        if(listener.exitCsExpressionRoot) {
             listener.exitCsExpressionRoot(this);
        }
    }
}


export class TextExpressionContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public eachStatement(): EachStatementContext[];
    public eachStatement(i: number): EachStatementContext | null;
    public eachStatement(i?: number): EachStatementContext[] | EachStatementContext | null {
        if (i === undefined) {
            return this.getRuleContexts(EachStatementContext);
        }

        return this.getRuleContext(i, EachStatementContext);
    }
    public ifStatement(): IfStatementContext[];
    public ifStatement(i: number): IfStatementContext | null;
    public ifStatement(i?: number): IfStatementContext[] | IfStatementContext | null {
        if (i === undefined) {
            return this.getRuleContexts(IfStatementContext);
        }

        return this.getRuleContext(i, IfStatementContext);
    }
    public interpolatedExpression(): InterpolatedExpressionContext[];
    public interpolatedExpression(i: number): InterpolatedExpressionContext | null;
    public interpolatedExpression(i?: number): InterpolatedExpressionContext[] | InterpolatedExpressionContext | null {
        if (i === undefined) {
            return this.getRuleContexts(InterpolatedExpressionContext);
        }

        return this.getRuleContext(i, InterpolatedExpressionContext);
    }
    public string_(): StringContext[];
    public string_(i: number): StringContext | null;
    public string_(i?: number): StringContext[] | StringContext | null {
        if (i === undefined) {
            return this.getRuleContexts(StringContext);
        }

        return this.getRuleContext(i, StringContext);
    }
    public override get ruleIndex(): number {
        return FrendsExpressionParser.RULE_textExpression;
    }
    public override enterRule(listener: FrendsExpressionParserListener): void {
        if(listener.enterTextExpression) {
             listener.enterTextExpression(this);
        }
    }
    public override exitRule(listener: FrendsExpressionParserListener): void {
        if(listener.exitTextExpression) {
             listener.exitTextExpression(this);
        }
    }
}


export class InterpolatedExpressionContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public OPEN_BRACES(): antlr.TerminalNode {
        return this.getToken(FrendsExpressionParser.OPEN_BRACES, 0)!;
    }
    public csExpression(): CsExpressionContext {
        return this.getRuleContext(0, CsExpressionContext)!;
    }
    public CLOSE_BRACES(): antlr.TerminalNode {
        return this.getToken(FrendsExpressionParser.CLOSE_BRACES, 0)!;
    }
    public override get ruleIndex(): number {
        return FrendsExpressionParser.RULE_interpolatedExpression;
    }
    public override enterRule(listener: FrendsExpressionParserListener): void {
        if(listener.enterInterpolatedExpression) {
             listener.enterInterpolatedExpression(this);
        }
    }
    public override exitRule(listener: FrendsExpressionParserListener): void {
        if(listener.exitInterpolatedExpression) {
             listener.exitInterpolatedExpression(this);
        }
    }
}


export class EachStatementContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public EACH_OPEN(): antlr.TerminalNode {
        return this.getToken(FrendsExpressionParser.EACH_OPEN, 0)!;
    }
    public nonEmptyCsExpression(): NonEmptyCsExpressionContext {
        return this.getRuleContext(0, NonEmptyCsExpressionContext)!;
    }
    public CLOSE_BRACES(): antlr.TerminalNode {
        return this.getToken(FrendsExpressionParser.CLOSE_BRACES, 0)!;
    }
    public textExpression(): TextExpressionContext {
        return this.getRuleContext(0, TextExpressionContext)!;
    }
    public END_EACH_TAG(): antlr.TerminalNode {
        return this.getToken(FrendsExpressionParser.END_EACH_TAG, 0)!;
    }
    public override get ruleIndex(): number {
        return FrendsExpressionParser.RULE_eachStatement;
    }
    public override enterRule(listener: FrendsExpressionParserListener): void {
        if(listener.enterEachStatement) {
             listener.enterEachStatement(this);
        }
    }
    public override exitRule(listener: FrendsExpressionParserListener): void {
        if(listener.exitEachStatement) {
             listener.exitEachStatement(this);
        }
    }
}


export class IfStatementContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public ifBranch(): IfBranchContext {
        return this.getRuleContext(0, IfBranchContext)!;
    }
    public END_IF_TAG(): antlr.TerminalNode {
        return this.getToken(FrendsExpressionParser.END_IF_TAG, 0)!;
    }
    public elseIfBranch(): ElseIfBranchContext[];
    public elseIfBranch(i: number): ElseIfBranchContext | null;
    public elseIfBranch(i?: number): ElseIfBranchContext[] | ElseIfBranchContext | null {
        if (i === undefined) {
            return this.getRuleContexts(ElseIfBranchContext);
        }

        return this.getRuleContext(i, ElseIfBranchContext);
    }
    public elseBranch(): ElseBranchContext | null {
        return this.getRuleContext(0, ElseBranchContext);
    }
    public override get ruleIndex(): number {
        return FrendsExpressionParser.RULE_ifStatement;
    }
    public override enterRule(listener: FrendsExpressionParserListener): void {
        if(listener.enterIfStatement) {
             listener.enterIfStatement(this);
        }
    }
    public override exitRule(listener: FrendsExpressionParserListener): void {
        if(listener.exitIfStatement) {
             listener.exitIfStatement(this);
        }
    }
}


export class IfBranchContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public IF_OPEN(): antlr.TerminalNode {
        return this.getToken(FrendsExpressionParser.IF_OPEN, 0)!;
    }
    public nonEmptyCsExpression(): NonEmptyCsExpressionContext {
        return this.getRuleContext(0, NonEmptyCsExpressionContext)!;
    }
    public CLOSE_BRACES(): antlr.TerminalNode {
        return this.getToken(FrendsExpressionParser.CLOSE_BRACES, 0)!;
    }
    public textExpression(): TextExpressionContext {
        return this.getRuleContext(0, TextExpressionContext)!;
    }
    public override get ruleIndex(): number {
        return FrendsExpressionParser.RULE_ifBranch;
    }
    public override enterRule(listener: FrendsExpressionParserListener): void {
        if(listener.enterIfBranch) {
             listener.enterIfBranch(this);
        }
    }
    public override exitRule(listener: FrendsExpressionParserListener): void {
        if(listener.exitIfBranch) {
             listener.exitIfBranch(this);
        }
    }
}


export class ElseIfBranchContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public ELSE_IF_OPEN(): antlr.TerminalNode {
        return this.getToken(FrendsExpressionParser.ELSE_IF_OPEN, 0)!;
    }
    public nonEmptyCsExpression(): NonEmptyCsExpressionContext {
        return this.getRuleContext(0, NonEmptyCsExpressionContext)!;
    }
    public CLOSE_BRACES(): antlr.TerminalNode {
        return this.getToken(FrendsExpressionParser.CLOSE_BRACES, 0)!;
    }
    public textExpression(): TextExpressionContext {
        return this.getRuleContext(0, TextExpressionContext)!;
    }
    public override get ruleIndex(): number {
        return FrendsExpressionParser.RULE_elseIfBranch;
    }
    public override enterRule(listener: FrendsExpressionParserListener): void {
        if(listener.enterElseIfBranch) {
             listener.enterElseIfBranch(this);
        }
    }
    public override exitRule(listener: FrendsExpressionParserListener): void {
        if(listener.exitElseIfBranch) {
             listener.exitElseIfBranch(this);
        }
    }
}


export class ElseBranchContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public ELSE_TAG(): antlr.TerminalNode {
        return this.getToken(FrendsExpressionParser.ELSE_TAG, 0)!;
    }
    public textExpression(): TextExpressionContext {
        return this.getRuleContext(0, TextExpressionContext)!;
    }
    public override get ruleIndex(): number {
        return FrendsExpressionParser.RULE_elseBranch;
    }
    public override enterRule(listener: FrendsExpressionParserListener): void {
        if(listener.enterElseBranch) {
             listener.enterElseBranch(this);
        }
    }
    public override exitRule(listener: FrendsExpressionParserListener): void {
        if(listener.exitElseBranch) {
             listener.exitElseBranch(this);
        }
    }
}


export class CsExpressionContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public reference(): ReferenceContext[];
    public reference(i: number): ReferenceContext | null;
    public reference(i?: number): ReferenceContext[] | ReferenceContext | null {
        if (i === undefined) {
            return this.getRuleContexts(ReferenceContext);
        }

        return this.getRuleContext(i, ReferenceContext);
    }
    public csText(): CsTextContext[];
    public csText(i: number): CsTextContext | null;
    public csText(i?: number): CsTextContext[] | CsTextContext | null {
        if (i === undefined) {
            return this.getRuleContexts(CsTextContext);
        }

        return this.getRuleContext(i, CsTextContext);
    }
    public override get ruleIndex(): number {
        return FrendsExpressionParser.RULE_csExpression;
    }
    public override enterRule(listener: FrendsExpressionParserListener): void {
        if(listener.enterCsExpression) {
             listener.enterCsExpression(this);
        }
    }
    public override exitRule(listener: FrendsExpressionParserListener): void {
        if(listener.exitCsExpression) {
             listener.exitCsExpression(this);
        }
    }
}


export class NonEmptyCsExpressionContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public reference(): ReferenceContext[];
    public reference(i: number): ReferenceContext | null;
    public reference(i?: number): ReferenceContext[] | ReferenceContext | null {
        if (i === undefined) {
            return this.getRuleContexts(ReferenceContext);
        }

        return this.getRuleContext(i, ReferenceContext);
    }
    public csText(): CsTextContext[];
    public csText(i: number): CsTextContext | null;
    public csText(i?: number): CsTextContext[] | CsTextContext | null {
        if (i === undefined) {
            return this.getRuleContexts(CsTextContext);
        }

        return this.getRuleContext(i, CsTextContext);
    }
    public override get ruleIndex(): number {
        return FrendsExpressionParser.RULE_nonEmptyCsExpression;
    }
    public override enterRule(listener: FrendsExpressionParserListener): void {
        if(listener.enterNonEmptyCsExpression) {
             listener.enterNonEmptyCsExpression(this);
        }
    }
    public override exitRule(listener: FrendsExpressionParserListener): void {
        if(listener.exitNonEmptyCsExpression) {
             listener.exitNonEmptyCsExpression(this);
        }
    }
}


export class ReferenceContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public varRef(): VarRefContext | null {
        return this.getRuleContext(0, VarRefContext);
    }
    public triggerRef(): TriggerRefContext | null {
        return this.getRuleContext(0, TriggerRefContext);
    }
    public processRef(): ProcessRefContext | null {
        return this.getRuleContext(0, ProcessRefContext);
    }
    public envRef(): EnvRefContext | null {
        return this.getRuleContext(0, EnvRefContext);
    }
    public resultNodeRef(): ResultNodeRefContext | null {
        return this.getRuleContext(0, ResultNodeRefContext);
    }
    public resultRef(): ResultRefContext | null {
        return this.getRuleContext(0, ResultRefContext);
    }
    public thisRef(): ThisRefContext | null {
        return this.getRuleContext(0, ThisRefContext);
    }
    public indexRef(): IndexRefContext | null {
        return this.getRuleContext(0, IndexRefContext);
    }
    public sourceRef(): SourceRefContext | null {
        return this.getRuleContext(0, SourceRefContext);
    }
    public override get ruleIndex(): number {
        return FrendsExpressionParser.RULE_reference;
    }
    public override enterRule(listener: FrendsExpressionParserListener): void {
        if(listener.enterReference) {
             listener.enterReference(this);
        }
    }
    public override exitRule(listener: FrendsExpressionParserListener): void {
        if(listener.exitReference) {
             listener.exitReference(this);
        }
    }
}


export class VarRefContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public VAR_REF(): antlr.TerminalNode {
        return this.getToken(FrendsExpressionParser.VAR_REF, 0)!;
    }
    public override get ruleIndex(): number {
        return FrendsExpressionParser.RULE_varRef;
    }
    public override enterRule(listener: FrendsExpressionParserListener): void {
        if(listener.enterVarRef) {
             listener.enterVarRef(this);
        }
    }
    public override exitRule(listener: FrendsExpressionParserListener): void {
        if(listener.exitVarRef) {
             listener.exitVarRef(this);
        }
    }
}


export class TriggerRefContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public TRIGGER_REF(): antlr.TerminalNode {
        return this.getToken(FrendsExpressionParser.TRIGGER_REF, 0)!;
    }
    public override get ruleIndex(): number {
        return FrendsExpressionParser.RULE_triggerRef;
    }
    public override enterRule(listener: FrendsExpressionParserListener): void {
        if(listener.enterTriggerRef) {
             listener.enterTriggerRef(this);
        }
    }
    public override exitRule(listener: FrendsExpressionParserListener): void {
        if(listener.exitTriggerRef) {
             listener.exitTriggerRef(this);
        }
    }
}


export class ProcessRefContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public PROCESS_REF(): antlr.TerminalNode {
        return this.getToken(FrendsExpressionParser.PROCESS_REF, 0)!;
    }
    public override get ruleIndex(): number {
        return FrendsExpressionParser.RULE_processRef;
    }
    public override enterRule(listener: FrendsExpressionParserListener): void {
        if(listener.enterProcessRef) {
             listener.enterProcessRef(this);
        }
    }
    public override exitRule(listener: FrendsExpressionParserListener): void {
        if(listener.exitProcessRef) {
             listener.exitProcessRef(this);
        }
    }
}


export class EnvRefContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public ENV_REF_START(): antlr.TerminalNode {
        return this.getToken(FrendsExpressionParser.ENV_REF_START, 0)!;
    }
    public ENV_VAR_VALUE(): antlr.TerminalNode | null {
        return this.getToken(FrendsExpressionParser.ENV_VAR_VALUE, 0);
    }
    public override get ruleIndex(): number {
        return FrendsExpressionParser.RULE_envRef;
    }
    public override enterRule(listener: FrendsExpressionParserListener): void {
        if(listener.enterEnvRef) {
             listener.enterEnvRef(this);
        }
    }
    public override exitRule(listener: FrendsExpressionParserListener): void {
        if(listener.exitEnvRef) {
             listener.exitEnvRef(this);
        }
    }
}


export class ResultNodeRefContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public RESULT_NODE_REF(): antlr.TerminalNode {
        return this.getToken(FrendsExpressionParser.RESULT_NODE_REF, 0)!;
    }
    public override get ruleIndex(): number {
        return FrendsExpressionParser.RULE_resultNodeRef;
    }
    public override enterRule(listener: FrendsExpressionParserListener): void {
        if(listener.enterResultNodeRef) {
             listener.enterResultNodeRef(this);
        }
    }
    public override exitRule(listener: FrendsExpressionParserListener): void {
        if(listener.exitResultNodeRef) {
             listener.exitResultNodeRef(this);
        }
    }
}


export class ResultRefContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public RESULT_REF(): antlr.TerminalNode {
        return this.getToken(FrendsExpressionParser.RESULT_REF, 0)!;
    }
    public override get ruleIndex(): number {
        return FrendsExpressionParser.RULE_resultRef;
    }
    public override enterRule(listener: FrendsExpressionParserListener): void {
        if(listener.enterResultRef) {
             listener.enterResultRef(this);
        }
    }
    public override exitRule(listener: FrendsExpressionParserListener): void {
        if(listener.exitResultRef) {
             listener.exitResultRef(this);
        }
    }
}


export class ThisRefContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public THIS_REF(): antlr.TerminalNode {
        return this.getToken(FrendsExpressionParser.THIS_REF, 0)!;
    }
    public override get ruleIndex(): number {
        return FrendsExpressionParser.RULE_thisRef;
    }
    public override enterRule(listener: FrendsExpressionParserListener): void {
        if(listener.enterThisRef) {
             listener.enterThisRef(this);
        }
    }
    public override exitRule(listener: FrendsExpressionParserListener): void {
        if(listener.exitThisRef) {
             listener.exitThisRef(this);
        }
    }
}


export class IndexRefContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public INDEX_REF(): antlr.TerminalNode {
        return this.getToken(FrendsExpressionParser.INDEX_REF, 0)!;
    }
    public override get ruleIndex(): number {
        return FrendsExpressionParser.RULE_indexRef;
    }
    public override enterRule(listener: FrendsExpressionParserListener): void {
        if(listener.enterIndexRef) {
             listener.enterIndexRef(this);
        }
    }
    public override exitRule(listener: FrendsExpressionParserListener): void {
        if(listener.exitIndexRef) {
             listener.exitIndexRef(this);
        }
    }
}


export class SourceRefContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public SOURCE_REF(): antlr.TerminalNode {
        return this.getToken(FrendsExpressionParser.SOURCE_REF, 0)!;
    }
    public override get ruleIndex(): number {
        return FrendsExpressionParser.RULE_sourceRef;
    }
    public override enterRule(listener: FrendsExpressionParserListener): void {
        if(listener.enterSourceRef) {
             listener.enterSourceRef(this);
        }
    }
    public override exitRule(listener: FrendsExpressionParserListener): void {
        if(listener.exitSourceRef) {
             listener.exitSourceRef(this);
        }
    }
}


export class CsTextContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CS_TEXT(): antlr.TerminalNode[];
    public CS_TEXT(i: number): antlr.TerminalNode | null;
    public CS_TEXT(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    	if (i === undefined) {
    		return this.getTokens(FrendsExpressionParser.CS_TEXT);
    	} else {
    		return this.getToken(FrendsExpressionParser.CS_TEXT, i);
    	}
    }
    public override get ruleIndex(): number {
        return FrendsExpressionParser.RULE_csText;
    }
    public override enterRule(listener: FrendsExpressionParserListener): void {
        if(listener.enterCsText) {
             listener.enterCsText(this);
        }
    }
    public override exitRule(listener: FrendsExpressionParserListener): void {
        if(listener.exitCsText) {
             listener.exitCsText(this);
        }
    }
}


export class StringContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public STRING(): antlr.TerminalNode[];
    public STRING(i: number): antlr.TerminalNode | null;
    public STRING(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    	if (i === undefined) {
    		return this.getTokens(FrendsExpressionParser.STRING);
    	} else {
    		return this.getToken(FrendsExpressionParser.STRING, i);
    	}
    }
    public override get ruleIndex(): number {
        return FrendsExpressionParser.RULE_string;
    }
    public override enterRule(listener: FrendsExpressionParserListener): void {
        if(listener.enterString) {
             listener.enterString(this);
        }
    }
    public override exitRule(listener: FrendsExpressionParserListener): void {
        if(listener.exitString) {
             listener.exitString(this);
        }
    }
}
